import API from "../../API/api";

export function setVehicleData(make, vehicle_model, year) {
    const data = {
        make,
        vehicle_model,
        year,
    };

    return API.POST({
        apiPath: `/api/v2/vehicle/`,
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
    })
        .done((res) => {
            Promise.resolve(res);
        })
        .catch((err) => {
            console.log(err);
        });
}

export function removeVehicleDetailsData(vehicleNotProvidedComment) {
    const data = {
        comment: vehicleNotProvidedComment,
    };

    return API.POST({
        apiPath: `/api/v2/vehicle/notprovided/`,
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
    })
        .done((res) => {
            Promise.resolve(res);
        }).catch((err) => {
            console.log(err);
        });
}
